// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2OF55","detailsBorder":"styles_detailsBorder__2foLa"};